// src/components/agents/AgentViewDialog.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Chip,
} from "@mui/material";

export default function AgentViewDialog({ open, onClose, agent }) {
  if (!agent) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Agent details</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" gutterBottom>
          {agent.name}
        </Typography>
        {agent.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {agent.description}
          </Typography>
        )}
        <Stack direction="row" spacing={1}>
          <Chip
            label={`Interactions: ${agent.totalInteractions ?? 0}`}
            size="small"
          />
          {agent.channelCount != null && (
            <Chip label={`Channels: ${agent.channelCount}`} size="small" />
          )}
          {agent.status && (
            <Chip label={agent.status} size="small" variant="outlined" />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
